import { PointBreakDown } from "../../types/karma-points/karma-points.type";
import { ADD_KARMA_POINTS, SET_KARMA_POINTS } from "./karma-points.action";

export interface KarmaPointsState {
  breakdown: PointBreakDown | null;
  communityBasePoints?: number;
  score?: number;
}

const INITIAL_STATE = {
  breakdown: null,
  communityBasePoints: 0,
  score: 0,
} as KarmaPointsState;

export function communityKarmaPointsReducer(
  state = INITIAL_STATE,
  action: any
) {
  switch (action.type) {
    case SET_KARMA_POINTS: // sets whole object
      // console.log('action.obj', action.obj);
      return action.obj;
    case ADD_KARMA_POINTS:
      return {
        ...state,
        score: add(state.score, action.points),
      };
    default:
      return state;
  }
}

/**
 * Add two numbers together. If any value is given as a string, it will be converted to a number.
 */
function add(a: number | string | undefined, b: number | string | undefined) {
  if (typeof a === "string") {
    a = parseInt(a);
  }
  if (typeof b === "string") {
    b = parseInt(b);
  }
  if (typeof a === "undefined") {
    a = 0;
  }
  if (typeof b === "undefined") {
    b = 0;
  }

  return a + b;
}
